module.exports = __webpack_public_path__ + "media/images/icons/ihra_twitter_share-976670b2eec103d1a94c783c2bb59c57.svg";